<template>
  <div>
    <Layout>
        <Content>
          <div class="main">
            <div class="recommend_carouse">
              <Carousel v-if="recommends.length > 0" v-model="recomend" autoplay autoplay-speed="5000" radius-dot :height="417">
                <CarouselItem v-for="r in recommends" :key="r.id">
                  <div class="recommend_carouse_item" :style="`background-image: url(${r.cover})`" @click="handleClick(r, 'LiveDetail', true)"></div>
                </CarouselItem>
              </Carousel>
              <div v-if="!loadingRecommend && recommends.length === 0" class="no-course-tip">
                <p class="title">暂无推荐</p>
              </div>
              <Spin size="large" fix v-if="loadingRecommend"></Spin>
            </div>
            <section class="recent_course">
                 <section class="recent_main">
                  <div class="tooltip">
                    <p class="tooltip_title">热门点播</p>
                    <!-- <p class="tooltip_subtitle">爱你所爱，行你所行，听从你心，无问西东</p> -->
                  </div>
                  <Row :gutter="20" class="record_main">
                    <i-col span="6" v-for="record in recordRecent" :key="record.id">
                      <Card :bordered="false" :padding="0">
                        <div @click="handleClick(record, 'RecordDetail')">
                          <img class="cover" :src="record.cover"/>
                          <div class="text">
                            <p class="title">{{record.title}}</p>
                            <!--<p class="publisher">{{record.publisherName}}</p>-->
                          </div>
                        </div>
                      </Card>
                    </i-col>
                    <Spin size="large" fix v-if="loadingRecord"></Spin>
                  </Row>
                  <div v-if="!loadingRecord && recordRecent.length === 0" class="no-course-tip no_pos">
                    <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
                    <p class="title">精彩课程，敬请期待</p>
                  </div>
                  <div class="more" @click="gotoRecord">
                    <span>查看更多</span>
                    <VuiIco class="ico-right ibang-arrow-right" :w="16"></VuiIco>
                  </div>
                </section>

                 <!--<section class="recent_main">
                  <div class="tooltip">
                    <p class="tooltip_title">橙三直播</p>
                  </div>
                  <Row :gutter="20" class="live_main">
                    <i-col span="6" v-for="live in liveRecent" :key="live.id">
                      <Card :bordered="false" :padding="0">
                        <div class="live_main_content" @click="handleClick(live, 'LiveDetail')">
                          <img class="cover" :src="live.cover"/>
                          <div class="text">
                            <p class="title">{{live.title}}</p>
                            <p class="date">
                              <span>{{live.expectStartTime | Date('{y}-{m}-{d}')}} </span>
                              <span class="time">{{live.expectStartTime | Date('{h}:{i}')}} - {{(live.expectStartTime + live.expectTime) | Date('{h}:{i}')}}</span>
                            </p>
                          </div>
                          <div class="state_tooltip" v-if="live.state === COURSE_STATE.LIVING">直播中</div>
                        </div>
                      </Card>
                    </i-col>
                    <Spin size="large" fix v-if="loadingLive"></Spin>
                  </Row>
                  <div v-if="!loadingLive && liveRecent.length === 0" class="no-course-tip no_pos">
                    <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
                    <p class="title">精彩课程，敬请期待</p>
                  </div>
                  <div class="more" @click="gotoLive">
                    <span>查看更多</span>
                    <VuiIco class="ico-right ibang-arrow-right" :w="16"></VuiIco>
                  </div>
                </section>-->

            </section>
          </div>
        </Content>
    </Layout>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/api/course'
import sensorHelp from '@/vendor/sensors/help'
import { HOME_PAGE_VISIT, SCHOOL_PAGE_CLICK } from '@/constant/sensorEvent'
import { COURSE_STATE } from '@/constant/constants'
export default {
  computed: {
    ...mapState('app', ['isLogin']),
  },
  data () {
    return {
      recomend: 0,
      recommends: [],
      liveRecent: [],
      recordRecent: [],
      loadingRecommend: false,
      loadingLive: false,
      loadingRecord: false,
      COURSE_STATE,
    }
  },
  mounted () {
    // 加载跳转到顶部
    window.scrollTo(0, 0)
    this.init()
    sensorHelp.track(HOME_PAGE_VISIT, {
      school_visit_time_hour: new Date().getHours(),
    })
  },
  methods: {
    init () {
      this.queryRecommend()
      this.queryLive()
      this.queryRecord()
    },
    async queryRecommend () {
      this.loadingRecommend = true
      this.recommends = await api.getHomeRecommend().finally(() => {
        this.loadingRecommend = false
      })
    },
    async queryLive () {
      this.loadingLive = true
      this.liveRecent = await api.getHomeLiveRecent().finally(() => {
        this.loadingLive = false
      })
      this.liveRecent.splice(4)
    },
    async queryRecord () {
      this.loadingRecord = true
      this.recordRecent = await api.getRecordRecommend(null, { paths: { type: 3 } }).finally(() => { // type类型 3-首页点播 ,4-点播轮播
        this.loadingRecord = false
      })
      this.recordRecent.splice(4)
    },
    gotoLive () {
      this.$router.push('/lives')
    },
    gotoRecord () {
      this.$router.push('/records')
    },
    handleClick (v, path, bool) {
      if (bool) {
        sensorHelp.track(SCHOOL_PAGE_CLICK, {
          position: 'recommend',
        })
      }
      if (v.enable) {
        this.$router.push({ name: path, params: { courseId: v.pkid || v.id || v.resourceId } })
      } else {
        if (this.isLogin) {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: v.enableSign })
        } else {
          this.$Message.error('请先登录')
          this.$router.push({ name: 'Login' })
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.main {
  margin: auto;
  .recommend_carouse {
    position: relative;
    max-width: 1040px;
    height: 417px;
    margin: 12px auto;
    .recommend_carouse_item {
      height: 100%;
      background-size: cover;
      background-position: center;
    }
  }
  .recent_course {
    min-width: 960px;
    max-width: 1040px;
    margin: auto;
    .recent_main {
      position: relative;
      margin-top: 56px;
      .live_main {
        position: relative;
        .live_main_content {
          .state_tooltip {
            position: absolute;
            background: #57BD58;
            color: #fff;
            padding: 0 6px;
            top: 111px;
            left: 8px;
            z-index: 2;
            border-radius: 2px;
          }
        }
      }
      .tooltip {
        position: relative;
        text-align: center;
        margin-bottom: 28px;
        .tooltip_title {
          font-size: 26px;
          margin-bottom: 16px;
        }
        .tooltip_subtitle {
          color: #666666;
        }
      }
      .more {
        font-size: 14px;
        color: #666666;
        margin: 28px auto 92px;
        text-align: center;
        width: 100px;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          color: #ED6C00;
        }
        .ico-right {
          vertical-align: -3px;
        }
      }
    }
    /deep/ .ivu-card {
      background: #f8f8f8;
      &:hover {
        box-shadow: 5px 5px 16px 0 rgba(33, 33, 33, 0.12);
        background: #fff;
      }
    }
    /deep/ .ivu-card-body {
      cursor: pointer;
      // border-radius: 4px;
      overflow: hidden;
      .cover {
        width: 100%;
        height: 140px;
      }
      .text {
        padding: 10px;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .publisher, .date {
          color: #868688;
          position: relative;
        }
        .date {
          .time {
            position: absolute;
            right: 0;
          }
        }
      }
    }
    /deep/ .ivu-col {
      padding: 10px;
    }
  }
  /deep/ .ivu-spin-dot {
    background-color: #ED6C00;
  }
  /deep/ .ivu-carousel-dots li button {
    background: #fff;
  }
}
</style>
